import type { ReactNode } from 'react'

import clsx from 'clsx'

/* Ícone + texto do hint que fica acima do CTA, no rail estreito (90-92px) dos
   cards de listagem de recurso (jornadas, missões, quizzes — ver MASTER §7).
   Consolida uma linha (`hintBase`) que Jornadas, Missões e Quizzes escreviam
   cada um por conta própria, com o mesmo bug nos três: ícone `items-center`
   contra um texto `text-right` que quebra em duas linhas no rail estreito
   ("Concluída em 30/07", "Inicia em 12h 19m") — cada linha quebrada
   right-aligned fica numa posição diferente, longe do ícone fixo à esquerda.

   `items-start` + ícone com `mt-px` (alinhado ao topo da primeira linha) e
   `text-left` (texto colado no ícone, quebra mantendo a mesma margem
   esquerda) resolvem isso. O grupo inteiro continua encostado à direita do
   rail — quem posiciona é o `items-end` do container pai, não este
   componente. */

export type CardHintProps = {
  icon?: ReactNode
  children: ReactNode
  className?: string
}

const CARD_HINT_BASE =
  'flex items-start gap-1 text-left text-2xs leading-snug text-gray-700'

export const CardHint = ({ icon, children, className }: CardHintProps) => (
  <span className={clsx(CARD_HINT_BASE, className)}>
    {icon && <span className="mt-px shrink-0">{icon}</span>}
    <span>{children}</span>
  </span>
)

CardHint.displayName = 'CardHint'
